<template>
  <div class="mb-7">
    <img
      class="snapshot w-100 mb-2"
      :src="quote.snapshotSrcUrl.replace('https://apxacnzxqo.cloudimg.io/v7/', 'https://')"
    />
    <p class="font-size-sm disclaimer" v-dynamic-content:pv_satellite_image_explanation></p>
    <!--2023-05-20: Temp removed progress bar because backend is not ready
    <progress-bar
      :percentage="quote.detailOverview.coverage * 100"
      :contentKey="'pv_package_coverage'"
      v-if="!multipleQuotes"
    ></progress-bar>
    -->
  </div>
</template>
<script>
// import ProgressBar from '@/components/main/progress/ProgressBar'

export default {
  props: ['quote'],
  name: 'DetailImage',
  components: {
    // ProgressBar,
  },
}
</script>
